import { Component } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './clientes-layout.component.html'
})
export class ClientesLayoutComponent {}



// WEBPACK FOOTER //
// ./src/app/modules/layouts/clientes/clientes-layout.component.ts